import { feature as topoToGeo } from "topojson-client";
import { selectAllShops } from "../reducers";
import { getCasesData, getRiskData, getSuburbByPostcodeData } from "../api"

const convertTopoIfNeeded = topologyObjectsName => json => {
    return topologyObjectsName
        ? topoToGeo(json, json.objects[topologyObjectsName])
        : json;
};
const toJSON = response => response.json();
const fetchJson = url => fetch(url).then(toJSON);

export const getGeoJSON = (url, topologyObjectsName) => {
    return dispatch => {
        dispatch({ type: "GEOJSON:REQUEST" });
        return fetchJson(url)
            .then(convertTopoIfNeeded(topologyObjectsName))
            .then(geojson =>
                dispatch({ type: "GEOJSON:SUCCESS", payload: geojson })
            )
            .catch(error =>
                dispatch({ type: "GEOJSON:FAILURE", payload: error })
            );
    };
};

const sheetId = "1-3hlehSaZ6OExvgQ1t9hxk7wEAOyPVTuthrfLfmeMP4";
const sheetTab = "Businesses+details";
const sheetServer = "holy-sheet";
export const sheetIdToUrl = id =>
    `https://${sheetServer}.visualise.today/sheet/${id}`;

export const getAllProjects = () => {
    return (dispatch, getState) => {
        return fetchJson(
            sheetIdToUrl(`${sheetId}?range='${encodeURIComponent(sheetTab)}'`)
        )
            .then(data => {
                dispatch({
                    type: "SHOP:ALL:SUCCESS",
                    payload: data,
                });
                const state = getState();
                const allShops = selectAllShops(state);
                dispatch({
                    type: "FILTERS:SET_INITIAL",
                    payload: allShops,
                });
            })
            .catch(err => {
                console.log(err);
                dispatch({ type: "SHOP:ALL:ERROR", payload: err });
            });
    };
};

export const getAllCases = () => {
    return (dispatch) => {
        return getCasesData()
            .then(data => {
                dispatch({
                    type: "CASES:ALL:SUCCESS",
                    payload: data,
                });
            })
            .catch(err => {
                console.log("wat");
                console.log(err);
                // dispatch({ type: "SHOP:ALL:ERROR", payload: err });
            });
    };
};

export const getRiskByPostcode = () => {
    return (dispatch) => {
        return getRiskData()
            .then(data => {
                dispatch({
                    type: "RISK:SUCCESS",
                    payload: data,
                });
            })
            .catch(err => {
                console.log("wat no risk");
                console.log(err);
            });
    };
};

export const getSuburbsByPostcode = () => {
    return (dispatch) => {
        return getSuburbByPostcodeData()
            .then(data => {
                dispatch({
                    type: "SUBURBS:SUCCESS",
                    payload: data,
                });
            })
            .catch(err => {
                console.log("wat no suburbs");
                console.log(err);
            });
    };
};





// WEBPACK FOOTER //
// ./src/actions/data.js